// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Rider brand */
  --teal: #00c6a7;
  --teal-dark: #009d87;
  --teal-tint: #e3fbf6;

  /* Merchant brand */
  --amber: #f59e0b;
  --amber-dark: #d97706;
  --amber-tint: #fef3e2;

  /* Vendor brand — matches AppBrand.emerald/emeraldDark in
     bikesdrop-business's own theme file exactly, same reasoning as teal/
     amber above tracing back to their in-app colors. */
  --emerald: #059669;
  --emerald-dark: #047857;
  --emerald-tint: #e7f7f1;

  /* Functional only — matches AppColors.danger in both the rider and
     merchant app's own theme files exactly. Never used decoratively. */
  --danger: #ef4444;

  /* Dark sections (hero, footer, investment, etc.) — a teal-tinted near
     black, not navy. Same hue family as --teal, just pushed to the dark
     end, so every color on this site now traces back to the rider/
     merchant apps' own two brand colors, nothing else. */
  --ink-900: #040f0c;
  --ink-800: #0a1f1a;
  --ink-700: #123a30;

  --text-dark: #111827;
  --text-grey: #6b7280;
  --text-mute: #9aa4b2;
  --bg-light: #f4f7fb;
  --bg-white: #ffffff;
  --border-soft: #e6ebf2;

  --radius-sm: 10px;
  --radius-md: 16px;
  --radius-lg: 24px;
  --radius-xl: 32px;
  --shadow-sm: 0 4px 16px rgba(17, 24, 39, 0.06);
  --shadow-md: 0 12px 32px rgba(17, 24, 39, 0.1);
  --shadow-teal: 0 14px 30px rgba(0, 198, 167, 0.28);
  --shadow-amber: 0 14px 30px rgba(245, 158, 11, 0.28);
  --max-width: 1180px;
  --font-display: 'Poppins', 'Segoe UI', sans-serif;
  --font-body: 'Inter', 'Segoe UI', sans-serif;

  /* Glassmorphism — the exact frosted-panel treatment already used across
     the rider/merchant app (BackdropFilter blur(22), ~0.3 alpha white
     border, soft shadow; see e.g. profile_screen.dart's floating header).
     --glass-light is for a frosted panel that has to stay legible over
     BOTH the dark hero/promo sections AND this site's many plain white
     sections, so its fill opacity is high enough to read as a clearly
     defined card even with nothing dark behind it (a lower, more
     "see-through" alpha looks great over a photo or a dark gradient, but
     turns invisible — card and text both — over flat white, which is
     most of this page). --glass-dark is for a frosted panel that's
     always over the ink-toned dark sections, where a much lower alpha
     still reads fine. */
  --glass-blur: 22px;
  --glass-light-bg: rgba(255, 255, 255, 0.78);
  --glass-light-border: rgba(255, 255, 255, 0.7);
  --glass-dark-bg: rgba(255, 255, 255, 0.08);
  --glass-dark-border: rgba(255, 255, 255, 0.16);
}

/* Frosted panel over a light/colored background. */
.glass {
  background: var(--glass-light-bg);
  backdrop-filter: blur(var(--glass-blur));
  -webkit-backdrop-filter: blur(var(--glass-blur));
  border: 1px solid var(--glass-light-border);
  box-shadow: var(--shadow-sm);
}

/* Frosted panel over the ink-toned dark sections. */
.glass-dark {
  background: var(--glass-dark-bg);
  backdrop-filter: blur(var(--glass-blur));
  -webkit-backdrop-filter: blur(var(--glass-blur));
  border: 1px solid var(--glass-dark-border);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3);
}

* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  font-family: var(--font-body);
  color: var(--text-dark);
  background: var(--bg-white);
  -webkit-font-smoothing: antialiased;
  overflow-x: hidden;
}

h1,
h2,
h3,
h4 {
  font-family: var(--font-display);
  margin: 0;
  color: var(--text-dark);
  line-height: 1.15;
}

p {
  margin: 0;
  color: var(--text-grey);
  line-height: 1.7;
}

a {
  text-decoration: none;
  color: inherit;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

img {
  max-width: 100%;
  display: block;
}

.icon {
  flex-shrink: 0;
  display: inline-block;
  vertical-align: middle;
}

.coming-soon {
  flex-shrink: 0;
  font-family: var(--font-display);
  font-size: 9.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--text-mute);
  background: var(--bg-light);
  border: 1px solid var(--border-soft);
  padding: 2px 8px;
  border-radius: 100px;
}

button {
  font-family: var(--font-body);
  cursor: pointer;
  border: none;
}

.container {
  width: 100%;
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 0 24px;
}

.section {
  padding: 96px 0;
}

.section--tight {
  padding: 72px 0;
}

.eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 12.5px;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  padding: 7px 16px;
  border-radius: 100px;
  margin-bottom: 18px;
}

.eyebrow--teal {
  color: var(--teal-dark);
  background: var(--teal-tint);
}

.eyebrow--amber {
  color: var(--amber-dark);
  background: var(--amber-tint);
}

.eyebrow--light {
  color: #fff;
  background: rgba(255, 255, 255, 0.14);
}

.section-heading {
  font-size: clamp(28px, 4vw, 40px);
  font-weight: 800;
  max-width: 720px;
}

.section-sub {
  margin-top: 16px;
  font-size: 16.5px;
  max-width: 640px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 15px;
  padding: 15px 30px;
  border-radius: 100px;
  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;
  white-space: nowrap;
}

.btn:active {
  transform: translateY(1px) scale(0.98);
}

.btn--teal {
  background: linear-gradient(135deg, var(--teal), var(--teal-dark));
  color: #fff;
  box-shadow: var(--shadow-teal);
}

.btn--teal:hover {
  box-shadow: 0 18px 36px rgba(0, 198, 167, 0.36);
  transform: translateY(-2px);
}

.btn--amber {
  background: linear-gradient(135deg, var(--amber), var(--amber-dark));
  color: #fff;
  box-shadow: var(--shadow-amber);
}

.btn--amber:hover {
  box-shadow: 0 18px 36px rgba(245, 158, 11, 0.36);
  transform: translateY(-2px);
}

.btn--ghost {
  background: rgba(255, 255, 255, 0.1);
  border: 1.5px solid rgba(255, 255, 255, 0.55);
  color: #fff;
}

.btn--ghost:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.btn--outline {
  background: #fff;
  border: 1.5px solid var(--border-soft);
  color: var(--text-dark);
}

.btn--outline:hover {
  border-color: var(--teal);
  color: var(--teal-dark);
  transform: translateY(-2px);
}

.btn--sm {
  padding: 11px 22px;
  font-size: 13.5px;
}

.btn--block {
  width: 100%;
  white-space: normal;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 100px;
  font-size: 12.5px;
  font-weight: 700;
  font-family: var(--font-display);
}

@media (max-width: 720px) {
  .section {
    padding: 64px 0;
  }
  .section--tight {
    padding: 48px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;;EAEpB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;;EAErB;;uDAEqD;EACrD,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;;EAEvB;uEACqE;EACrE,iBAAiB;;EAEjB;;;yDAGuD;EACvD,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;;EAEtB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,8CAA8C;EAC9C,8CAA8C;EAC9C,kDAAkD;EAClD,oDAAoD;EACpD,mBAAmB;EACnB,iDAAiD;EACjD,4CAA4C;;EAE5C;;;;;;;;;;;wBAWsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,8CAA8C;EAC9C,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA,mDAAmD;AACnD;EACE,iCAAiC;EACjC,wCAAwC;EACxC,gDAAgD;EAChD,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA,oDAAoD;AACpD;EACE,gCAAgC;EAChC,wCAAwC;EACxC,gDAAgD;EAChD,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;;;;EAIE,gCAAgC;EAChC,SAAS;EACT,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,oCAAoC;EACpC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,2EAA2E;EAC3E,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kEAAkE;EAClE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,oEAAoE;EACpE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&family=Inter:wght@400;500;600;700&display=swap');\n\n:root {\n  /* Rider brand */\n  --teal: #00c6a7;\n  --teal-dark: #009d87;\n  --teal-tint: #e3fbf6;\n\n  /* Merchant brand */\n  --amber: #f59e0b;\n  --amber-dark: #d97706;\n  --amber-tint: #fef3e2;\n\n  /* Vendor brand — matches AppBrand.emerald/emeraldDark in\n     bikesdrop-business's own theme file exactly, same reasoning as teal/\n     amber above tracing back to their in-app colors. */\n  --emerald: #059669;\n  --emerald-dark: #047857;\n  --emerald-tint: #e7f7f1;\n\n  /* Functional only — matches AppColors.danger in both the rider and\n     merchant app's own theme files exactly. Never used decoratively. */\n  --danger: #ef4444;\n\n  /* Dark sections (hero, footer, investment, etc.) — a teal-tinted near\n     black, not navy. Same hue family as --teal, just pushed to the dark\n     end, so every color on this site now traces back to the rider/\n     merchant apps' own two brand colors, nothing else. */\n  --ink-900: #040f0c;\n  --ink-800: #0a1f1a;\n  --ink-700: #123a30;\n\n  --text-dark: #111827;\n  --text-grey: #6b7280;\n  --text-mute: #9aa4b2;\n  --bg-light: #f4f7fb;\n  --bg-white: #ffffff;\n  --border-soft: #e6ebf2;\n\n  --radius-sm: 10px;\n  --radius-md: 16px;\n  --radius-lg: 24px;\n  --radius-xl: 32px;\n  --shadow-sm: 0 4px 16px rgba(17, 24, 39, 0.06);\n  --shadow-md: 0 12px 32px rgba(17, 24, 39, 0.1);\n  --shadow-teal: 0 14px 30px rgba(0, 198, 167, 0.28);\n  --shadow-amber: 0 14px 30px rgba(245, 158, 11, 0.28);\n  --max-width: 1180px;\n  --font-display: 'Poppins', 'Segoe UI', sans-serif;\n  --font-body: 'Inter', 'Segoe UI', sans-serif;\n\n  /* Glassmorphism — the exact frosted-panel treatment already used across\n     the rider/merchant app (BackdropFilter blur(22), ~0.3 alpha white\n     border, soft shadow; see e.g. profile_screen.dart's floating header).\n     --glass-light is for a frosted panel that has to stay legible over\n     BOTH the dark hero/promo sections AND this site's many plain white\n     sections, so its fill opacity is high enough to read as a clearly\n     defined card even with nothing dark behind it (a lower, more\n     \"see-through\" alpha looks great over a photo or a dark gradient, but\n     turns invisible — card and text both — over flat white, which is\n     most of this page). --glass-dark is for a frosted panel that's\n     always over the ink-toned dark sections, where a much lower alpha\n     still reads fine. */\n  --glass-blur: 22px;\n  --glass-light-bg: rgba(255, 255, 255, 0.78);\n  --glass-light-border: rgba(255, 255, 255, 0.7);\n  --glass-dark-bg: rgba(255, 255, 255, 0.08);\n  --glass-dark-border: rgba(255, 255, 255, 0.16);\n}\n\n/* Frosted panel over a light/colored background. */\n.glass {\n  background: var(--glass-light-bg);\n  backdrop-filter: blur(var(--glass-blur));\n  -webkit-backdrop-filter: blur(var(--glass-blur));\n  border: 1px solid var(--glass-light-border);\n  box-shadow: var(--shadow-sm);\n}\n\n/* Frosted panel over the ink-toned dark sections. */\n.glass-dark {\n  background: var(--glass-dark-bg);\n  backdrop-filter: blur(var(--glass-blur));\n  -webkit-backdrop-filter: blur(var(--glass-blur));\n  border: 1px solid var(--glass-dark-border);\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3);\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-body);\n  color: var(--text-dark);\n  background: var(--bg-white);\n  -webkit-font-smoothing: antialiased;\n  overflow-x: hidden;\n}\n\nh1,\nh2,\nh3,\nh4 {\n  font-family: var(--font-display);\n  margin: 0;\n  color: var(--text-dark);\n  line-height: 1.15;\n}\n\np {\n  margin: 0;\n  color: var(--text-grey);\n  line-height: 1.7;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\nul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\nimg {\n  max-width: 100%;\n  display: block;\n}\n\n.icon {\n  flex-shrink: 0;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.coming-soon {\n  flex-shrink: 0;\n  font-family: var(--font-display);\n  font-size: 9.5px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--text-mute);\n  background: var(--bg-light);\n  border: 1px solid var(--border-soft);\n  padding: 2px 8px;\n  border-radius: 100px;\n}\n\nbutton {\n  font-family: var(--font-body);\n  cursor: pointer;\n  border: none;\n}\n\n.container {\n  width: 100%;\n  max-width: var(--max-width);\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.section {\n  padding: 96px 0;\n}\n\n.section--tight {\n  padding: 72px 0;\n}\n\n.eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: 12.5px;\n  letter-spacing: 1.4px;\n  text-transform: uppercase;\n  padding: 7px 16px;\n  border-radius: 100px;\n  margin-bottom: 18px;\n}\n\n.eyebrow--teal {\n  color: var(--teal-dark);\n  background: var(--teal-tint);\n}\n\n.eyebrow--amber {\n  color: var(--amber-dark);\n  background: var(--amber-tint);\n}\n\n.eyebrow--light {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.section-heading {\n  font-size: clamp(28px, 4vw, 40px);\n  font-weight: 800;\n  max-width: 720px;\n}\n\n.section-sub {\n  margin-top: 16px;\n  font-size: 16.5px;\n  max-width: 640px;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: 15px;\n  padding: 15px 30px;\n  border-radius: 100px;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;\n  white-space: nowrap;\n}\n\n.btn:active {\n  transform: translateY(1px) scale(0.98);\n}\n\n.btn--teal {\n  background: linear-gradient(135deg, var(--teal), var(--teal-dark));\n  color: #fff;\n  box-shadow: var(--shadow-teal);\n}\n\n.btn--teal:hover {\n  box-shadow: 0 18px 36px rgba(0, 198, 167, 0.36);\n  transform: translateY(-2px);\n}\n\n.btn--amber {\n  background: linear-gradient(135deg, var(--amber), var(--amber-dark));\n  color: #fff;\n  box-shadow: var(--shadow-amber);\n}\n\n.btn--amber:hover {\n  box-shadow: 0 18px 36px rgba(245, 158, 11, 0.36);\n  transform: translateY(-2px);\n}\n\n.btn--ghost {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1.5px solid rgba(255, 255, 255, 0.55);\n  color: #fff;\n}\n\n.btn--ghost:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n}\n\n.btn--outline {\n  background: #fff;\n  border: 1.5px solid var(--border-soft);\n  color: var(--text-dark);\n}\n\n.btn--outline:hover {\n  border-color: var(--teal);\n  color: var(--teal-dark);\n  transform: translateY(-2px);\n}\n\n.btn--sm {\n  padding: 11px 22px;\n  font-size: 13.5px;\n}\n\n.btn--block {\n  width: 100%;\n  white-space: normal;\n}\n\n.pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: 100px;\n  font-size: 12.5px;\n  font-weight: 700;\n  font-family: var(--font-display);\n}\n\n@media (max-width: 720px) {\n  .section {\n    padding: 64px 0;\n  }\n  .section--tight {\n    padding: 48px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
